import React from "react";

const CustomEvent = ({ event }) => {
  return (
    <div className="p-2 bg-blue-100 rounded shadow text-xs">
      <div className="font-bold text-sm truncate">{event.title}</div>

      {event.leadName && (
        <div className="text-gray-700">🔗 {event.leadName}</div>
      )}

      {event.description && (
        <div className="text-gray-600 truncate">📝 {event.description}</div>
      )}

      {event.meetLink && (
        <div className="mt-1">
          <a
            href={event.meetLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            🔗 Apri Meet
          </a>
        </div>
      )}
    </div>
  );
};

export default CustomEvent;
